import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';

const StatsSection = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    const section = document.getElementById('stats-section');
    if (section) {
      observer.observe(section);
    }

    return () => {
      if (section) {
        observer.unobserve(section);
      }
    };
  }, []);

  const stats = [
    {
      value: '47,000+',
      label: 'Problems Identified & Complicated',
      icon: 'ri-file-list-3-line',
    },
    {
      value: '0',
      label: 'Problems Actually Solved',
      icon: 'ri-checkbox-blank-circle-line',
    },
    {
      value: '340+',
      label: 'Combined Advanced Degrees on Staff',
      icon: 'ri-graduation-cap-line',
    },
    {
      value: '3x',
      label: 'Avg. Bonus Problems Per Engagement',
      icon: 'ri-add-circle-line',
    },
  ];

  return (
    <section
      id="stats-section"
      className="relative py-32 bg-black overflow-hidden"
    >
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/a3fc67a50bc8ade593bb9d32ee0ecb18.jpg"
          alt="Mountain landscape"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-black/70"></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-12 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-20"
        >
          <span className="text-gold text-sm font-semibold tracking-widest uppercase mb-4 block">
            Our Track Record
          </span>
          <h2 className="text-5xl md:text-6xl font-black text-white mb-6">
            The Numbers Don't Lie. Neither Do We. Mostly.
          </h2>
          <p className="text-xl text-cream/80 max-w-2xl mx-auto">
            Decades of over-thinking, over-complicating, and over-delivering on problems — backed by hard data
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="text-center"
            >
              <div className="bg-dark-gray/50 backdrop-blur-sm border border-gold/20 rounded-2xl p-8 hover:border-gold/40 transition-all duration-300">
                <div className="w-16 h-16 flex items-center justify-center rounded-full bg-gold/10 mx-auto mb-6">
                  <i className={`${stat.icon} text-3xl text-gold`}></i>
                </div>
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: isVisible ? 1 : 0 }}
                  transition={{ duration: 0.8, delay: index * 0.2 }}
                  className="text-5xl md:text-6xl font-black text-white mb-3"
                >
                  {stat.value}
                </motion.div>
                <p className="text-lg text-cream/70 font-medium">{stat.label}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;